import React from 'react';
import {concatenate} from "services/string";

type Props = {
    index?: number
    highlight?: boolean
    children?: React.ReactNode
}

function TableRow(props: Props) {
    const {index, highlight, children} = props

    return (
        <tr className={concatenate(
                index !== undefined? (index % 2 === 0? 'bg-white' : 'bg-gray-50') : null,
                highlight? 'hover:bg-brand/5' : null,
                'group'
        )}>
            {children}
        </tr>
    );
}

export default TableRow;